function isTruthy(value) {
  return value === true || value === "true" || value === "t" || value === 1;
}

export const DEFAULT_GTFS_DIRECTION_IDS = { inbound: "1", outbound: "0" };

export function getDirectionControlLabelsFromStop(stop) {
  if (!stop?.direction_a_label && !stop?.direction_b_label) {
    return null;
  }

  return {
    inbound: stop?.direction_a_label || "Inbound",
    outbound: stop?.direction_b_label || "Outbound",
  };
}

export function shouldShowDirectionPicker(stop, stopType) {
  if ((stop?.stop_type || stopType) === "bus") {
    return false;
  }

  if (stop?.direction_selector_enabled != null) {
    return isTruthy(stop.direction_selector_enabled);
  }

  return isTruthy(stop?.supports_direction_selector);
}

/**
 * @deprecated `is_terminus` is an old client-compatibility field, not a
 * topological terminal classification. New clients must use
 * `supports_direction_selector` (and `direction_selector_enabled` when
 * present) to decide whether to show a direction picker.
 */
export function getLegacyIsTerminus(stop, stopType) {
  const resolvedStopType = stop?.stop_type || stopType;

  if (!resolvedStopType || resolvedStopType === "bus") {
    return false;
  }

  return !shouldShowDirectionPicker(stop, resolvedStopType);
}

export function getGtfsDirectionIdForRequestDirection(
  requestedDirection,
  mapping = DEFAULT_GTFS_DIRECTION_IDS,
) {
  if (requestedDirection === "inbound") {
    return mapping.inbound ?? null;
  }

  if (requestedDirection === "outbound") {
    return mapping.outbound ?? null;
  }

  return null;
}

export function getDirectionKeyFromRequestDirection(requestedDirection) {
  if (requestedDirection === "inbound") {
    return "direction_a";
  }

  if (requestedDirection === "outbound") {
    return "direction_b";
  }

  return null;
}

/**
 * Filter departures using reviewed station/platform direction metadata when
 * available. Provider GTFS direction ids are only a fallback because their
 * meaning can change between routes within the same region.
 */
export function filterDeparturesByDirection({
  departures,
  directionKey,
  requestedDirection,
  directionIdMapping = DEFAULT_GTFS_DIRECTION_IDS,
  stationPlatformMetadata,
}) {
  const allowedStopIds = directionKey
    ? stationPlatformMetadata?.byDirection?.get(directionKey) || []
    : [];

  // A partially mapped station must not switch direction conventions for its
  // missing group. Only stations without curated directions use GTFS ids.
  if (directionKey && stationPlatformMetadata?.byDirection?.size) {
    return departures.filter((departure) =>
      allowedStopIds.includes(String(departure.stop_id)),
    );
  }

  const directionId = getGtfsDirectionIdForRequestDirection(
    requestedDirection,
    directionIdMapping,
  );

  if (directionId !== null && directionId !== undefined) {
    return departures.filter(
      (departure) => String(departure.direction_id) === String(directionId),
    );
  }

  return departures;
}
